import axios from 'axios'
import { atenyaUser } from 'constant/const'
import { jwtTokenVerify } from './jwtTokenVerify'

const axiosInstance = axios.create({
   baseURL: process.env.REACT_APP_BACKEND_URL + "/api",
   headers: {
      'Content-Type': 'application/json'
   }
})

axiosInstance.interceptors.request.use(
   async (config) => {
      try {
         const authHeader = JSON.parse(localStorage.getItem(atenyaUser))?.access
         if (authHeader) {
            config.headers.Authorization = `Bearer ${authHeader}`
         }
         return config
      } catch (error) {
         console.error('Error setting Authorization header :', error)
         return Promise.reject(error)
      }
   },
   (error) => {
      console.error('Request interceptor error :', error)
      return Promise.reject(error)
   }
)

axiosInstance.interceptors.response.use(
   async (response) => {
      try {
         return response
      } catch (error) {
         console.error('Error setting Authorization:', error)
         return Promise.reject(error)
      }
   },
   (error) => {
      if (error.response?.data?.ResponseCode === 401) {
         const user = JSON.parse(localStorage.getItem(atenyaUser))
         if (user && user?.access) {
            let logOutUser = jwtTokenVerify(user)
            if (logOutUser) {
               localStorage.removeItem(atenyaUser)
               setTimeout(() => {
                  window.location.assign('/auth/login')
               }, 1000)
            }
         }
      }
      console.error('Request interceptor error:', error)
      return Promise.reject(error)
   }
)

export default axiosInstance
